import { TranslateService } from '@ngx-translate/core';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { MediaBlockReason } from '@nimbus-global/features/chat/models/chat-twilio.model';

export function getMediaBlockReasonMessage(blockReason: MediaBlockReason, translateService: TranslateService): string {
  switch (blockReason) {
    case MediaBlockReason.NoPolicyAssigned:
      return translateService.instant(TranslationKeys.ChatWidgetMessageAttachmentBlockedTooltipNoPolicyAssigned);
    case MediaBlockReason.UnknownFileType:
      return translateService.instant(TranslationKeys.ChatWidgetMessageAttachmentBlockedTooltipUnknownFileType);
    case MediaBlockReason.TooLarge:
      return translateService.instant(TranslationKeys.ChatWidgetMessageAttachmentBlockedTooltipTooLarge);
    case MediaBlockReason.PolicyUnavailable:
      return translateService.instant(TranslationKeys.ChatWidgetMessageAttachmentBlockedTooltipPolicyUnavailable);
    case MediaBlockReason.FileTypeMismatch:
      return translateService.instant(TranslationKeys.ChatWidgetMessageAttachmentBlockedTooltipFileTypeMismatch);
    case MediaBlockReason.FileTypeNotAllowed:
    case MediaBlockReason.ChannelNotAllowed:
    default:
      return translateService.instant(TranslationKeys.ChatWidgetMessageAttachmentBlockedTooltipFileTypeNotAllowed);
  }
}
